export const CLIENT_JOURNEY_STATE_IS_LOADING =
  'CLIENT_JOURNEY_STATE_IS_LOADING';
